import axios from 'axios';
import Swal from 'sweetalert2';
import ACTION_ITEMS from '../actionItems';

export const fetchTeamCandidates = (sponsorId) => (dispatch) => {
  Swal.fire({
    onBeforeOpen: () => {
      Swal.showLoading();
    },
  });
  axios
    .get(`/sponsor/${sponsorId}/sponsees`)
    .then((response) => {
      const { status, sponsees } = response.data;
      if (status === 'SUCCESS') {
        dispatch({
          type: ACTION_ITEMS.TEAM_VIEWER.USERS.SET,
          payload: sponsees,
        });
      }
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      Swal.close();
    });
};

export const setSelectedCandidate = (user) => {
  return {
    type: ACTION_ITEMS.TEAM_VIEWER.SELECTED_CANDIDATE.SET,
    payload: user,
  };
};

export const fetchCompany = (companyId) => {
  return {
    type: ACTION_ITEMS.TEAM_VIEWER.COMPANIES.ADD,
    payload: {
      id: companyId,
      name: `Texaco -${companyId}`,
    },
  };
};

